import {Button, Paper, Select, Switch} from "@mantine/core";
import { ArrowLeft as IconArrowLeft, PaperPlaneRight as IconSend } from "@phosphor-icons/react";
import {DataTable} from "mantine-datatable";
import {useContext, useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router";
import withRouteErrorBoundary from "../../components/ErrorBoundary/withRouteErrorBoundary.tsx";
import {Row, Col} from "../../components/Flex/Flex";
import Page from "../../components/Page/Page.tsx";
import MessageContext from "../../context/MessageContext.tsx";
import api from "../../utils/api.ts";
import {bodyExpiration} from "./ContractList/ContractList.jsx";
import {bodyReward, bodyType} from "./ContractList/Formatters.jsx";

const bodyScans = row => row.scans.length;

function TransferContract () {
    const {state} = useLocation();
    const navigate = useNavigate();
    const {success, error} = useContext(MessageContext);
    const [users, setUsers] = useState([]);
    const [sendTo, setSendTo] = useState('');
    const [includeNotes, setIncludeNotes] = useState(false);

    useEffect(() => {
        if(typeof state?.contracts === 'undefined' || state?.contracts.length === 0) {
            navigate('/bh/contracts', {replace: true});
            return;
        }
        api.get('/users').then(res => {
            setUsers(res.data.sort((a,b) => a.handle.localeCompare(b.handle)));
        });
    }, []);

    const transfer = () => {
        let ids = state?.contracts.map(c => c.id);
        api.post('/bh/contracts/transfer', {ids, owner: sendTo, notes: includeNotes}).then(() => {
            success('Contracts have been transferred');
            navigate('/bh/contracts');
        }).catch(err => {
            if(err.response?.data?.error) {
                error('Error transferring contracts', err.response.data.error);
            } else {
                error('Error transferring contracts');
            }
        })
    }

    return (
        <Page>
            <title>Transfer Contracts</title>
            <Paper>
                <Row>
                    <Col><Button leftSection={<IconArrowLeft size={16}/>} onClick={() => navigate('/bh/contracts')}>Back</Button></Col>
                    <Col grow={1} />
                    <Col><Button leftSection={<IconSend size={16}/>} onClick={transfer}>Transfer contracts</Button></Col>
                </Row>

                <p>You are transferring {state?.contracts.length} contracts to another user.</p>
                <Row align="end">
                    <Col basis="200px">
                        <Select value={sendTo || null} onChange={v => setSendTo(v || '')} data={users.map(u => ({value: u.uid, label: u.handle}))} placeholder="Select new owner" searchable />
                    </Col>
                    <Col>
                        <Switch id="notes" checked={includeNotes} onChange={e => setIncludeNotes(e.currentTarget.checked)} label="Include notes" />
                    </Col>
                </Row>

                <h4>Contracts</h4>
                <DataTable
                    records={state?.contracts || []}
                    idAccessor="id"
                    columns={[
                        {accessor: 'name', title: 'Target Name'},
                        {accessor: 'expiration', title: 'Expiration', render: bodyExpiration},
                        {accessor: 'scans', title: 'Scans', render: bodyScans},
                        {accessor: 'difficulty', title: 'Difficulty'},
                        {accessor: 'type', title: 'Type', render: bodyType},
                        {accessor: 'reward', title: 'Reward', render: bodyReward},
                        {accessor: 'notes', title: 'Notes'},
                    ]}
                />
            </Paper>
        </Page>
    );
}


export default withRouteErrorBoundary(TransferContract);
